import { render, staticRenderFns } from "./ReviewListItem.vue?vue&type=template&id=86a0ed3e&scoped=true&lang=pug"
import script from "./ReviewListItem.vue?vue&type=script&lang=js"
export * from "./ReviewListItem.vue?vue&type=script&lang=js"
import style0 from "./ReviewListItem.vue?vue&type=style&index=0&id=86a0ed3e&prod&lang=scss&scoped=true"
import style1 from "./ReviewListItem.vue?vue&type=style&index=1&id=86a0ed3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a0ed3e",
  null
  
)

export default component.exports